const productionConfig = {
    vodaPayIntegrationHost: "https://sms-sa.migration.penroseza.co.za/vodapay-integration",
    assetHost: "https://fanclash.blob.core.windows.net/fanclash-web-portal/vodacom-sa/V5",
    brand: "vodacom",
    scorePredictorService: "https://predictor-vodacomfantasy-com.migration-1.penrosesystems.com/score-predictor-service",
    upstreamIntegrationService: "https://sms-sa.migration.penroseza.co.za/upstream",
    fantasyHost: "https://fantasydribble-com.migration-1.penrosesystems.com",
    predictorHost: "https://predictor-vodacomfantasy-com.migration-1.penrosesystems.com",
    freePlayHost: "https://freepredictor-fantasydribble-com.migration-1.penrosesystems.com",
    rugbyHost: "https://rugby-zone-co-za.migration-1.penrosesystems.com",
    appEnv: "production",
    vodacomIntegratiojnService: "https://vodacomfantasy-com.migration-1.penrosesystems.com/utils-service",
    hyveAwsUrl: "partners-api.hyvesdp.com",
    proxyServiceUrl: "https://sms-sa.migration.penroseza.co.za/utils/proxy",
    infinityApi: "https://vodacomfantasy-com.migration-1.penrosesystems.com/api",
    hyveAwsAccessKey: "AKIAVPFRGEIV4VAFLWWU",
    hyveAwsAccessSecret: "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",
    hyveAwsApiKey: "J02RsCij3e8ykFf1FZIJN1z8bCfYMG5U8Lt1CdGD",
    rubgyRedirectUrl: "https://rugby-zone-co-za.migration-1.penrosesystems.com/home/HyveSubscribed",
    utilsService: "https://sms-sa.migration.penroseza.co.za/utils",
    termsConditionsHost: "https://termsandconditions-quizinc-co-za.migration.penrosesystems.com/",
    dcbService : "https://vodacom-za.migration.penroseza.co.za"
}

const stagingConfig = {
    vodaPayIntegrationHost: "https://sms-sa.migration.penroseza.co.za/vodapay-integration",
    assetHost: "https://fanclash.blob.core.windows.net/fanclash-web-portal/vodacom-sa/V5",
    brand: "vodacom",
    scorePredictorService: "https://predictor-vodacomfantasy-com.migration-1.penrosesystems.com/score-predictor-service",
    upstreamIntegrationService: "https://staging.sms-sa.migration.penroseza.co.za/upstream",
    fantasyHost: "https://fantasydribble-com.migration-1.penrosesystems.com",
    predictorHost: "https://predictor-vodacomfantasy-com.migration-1.penrosesystems.com",
    freePlayHost: "https://freepredictor-fantasydribble-com.migration-1.penrosesystems.com",
    rugbyHost: "https://rugby-zone-co-za.migration-1.penrosesystems.com",
    appEnv: "production",
    vodacomIntegratiojnService: "https://vodacomfantasy-com.migration-1.penrosesystems.com/utils-service",
    hyveAwsUrl: "partners-api.hyvesdp.com",
    proxyServiceUrl: "https://sms-sa.migration.penroseza.co.za/utils/proxy",
    infinityApi: "https://vodacomfantasy-com.migration-1.penrosesystems.com/api",
    hyveAwsAccessKey: "AKIAVPFRGEIV4VAFLWWU",
    hyveAwsAccessSecret: "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",
    hyveAwsApiKey: "J02RsCij3e8ykFf1FZIJN1z8bCfYMG5U8Lt1CdGD",
    rubgyRedirectUrl: "https://rugby-zone-co-za.migration-1.penrosesystems.com/home/HyveSubscribed",
    utilsService: "https://sms-sa.migration.penroseza.co.za/utils",
    termsConditionsHost: "https://termsandconditions-quizinc-co-za.migration.penrosesystems.com/",
    dcbService : "https://vodacom-za.migration.penroseza.co.za"
}

const environment = getEnvironnment()

export const environmentConfig = getEnvObject();


function getEnvironnment() {
    var base_url = window.location.origin;
    if (base_url.includes('staging')) return 'staging'
    if (base_url.includes('localhost')) return 'development'
    else return 'production'
}

function getEnvObject() {
    if (environment === 'staging') return stagingConfig
    if (environment === 'development') return productionConfig
    if (environment === 'production') return productionConfig
}
